import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
  settings: {
    isVisibleNumber: true,
    isVisibleForbidden: true,
    isVisibleCoordinate: true,
    isVisibleNextMove: true,
    isVisibleLastMoveMark: true,
    isVisibleGameInfo: true,
    isVisibleTitle: true,
    isVisiblePlayerName: true,
    isVisibleGameResult: true,
    isVisibleDonor: false,
  }
}

const settingsDialog = (state = initialState, action) => {
  switch (action.type) {
    case types.settingsDialog.OPEN:
      return { ...state, open: true }
    case types.settingsDialog.CLOSE:
      return { ...state, open: false }
    case types.settingsDialog.INITIALIZE:
      return { ...state, settings: { ...state.settings, ...action.settings } }
    case types.settingsDialog.CHANGED_CHECKBOX:
      return { ...state, settings: { ...state.settings, [action.name]: action.checked } }
    default:
      return state
  }
}

export default settingsDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/SettingsDialog.js